import {styled} from '@mui/material';

const Table = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  transition: '0.25s opacity ease-in-out',
  width: '100%',

  '&.loading': {
    opacity: 0.4,
    pointerEvents: 'none'
  },
}));

const Row = styled('div')(({theme}) => ({
  display: 'flex',
  borderBottom: `2px solid ${theme.palette.grey['100']}`,

  '&:last-of-type': {
    borderBottom: 0,
  }
}));

const Column = styled('div')(({theme}) => ({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  padding: theme.spacing(1),
}));

const Actions = styled(Row)(({theme}) => ({
  justifyContent: 'flex-end',
  padding: theme.spacing(1),

  '& h3': {
    alignSelf: 'center',
    color: theme.palette.secondary.main,
    flex: 1,
    fontSize: '1.4em',
    margin: 0,
    padding: 0
  },
}));

const NoRecords = styled(Row)(({theme}) => ({
  padding: theme.spacing(1),
  justifyContent: 'center',
}));

const Header = styled(Column)(() => ({
  fontWeight: '700',
}));

const Action = styled('div')(() => ({
  alignItems: 'center',
  display: 'flex',
  flex: '0 0 50px',
  justifyContent: 'center',
  padding: 5,
  width: 50
}));

Table.Row = Row;
Table.Column = Column;
Table.Header = Header;
Table.Actions = Actions;
Table.Action = Action;
Table.NoRecords = NoRecords;

export default Table;
